<template>
  <v-navigation-drawer
    v-if="weirdSlideAnimationAvoided"
    v-bind="navConfig || defaultConfig"
    :value="value"
    touchless
    :style="{
      width: 'clamp(967px, calc(100vw - 400px), 1200px)',
    }"
  >
    <div
      class="cmp-plugin-sidewindow"
      ref="cmp-plugin-sidewindow"
      @keyup="onKeyup"
      tabindex="0"
    >
      <div class="cmp-plugin-sidewindow--options">
        <div class="dt-icon-container">
          <img
            @click="onCloseSidewindowClick"
            src="static/icons/close-icon.svg"
            class="dt-icon v5 close-button h1 s2"
            alt="Close Sidewidnow"
            title="Close Sidewidnow"
          />
        </div>
      </div>
      <slot></slot>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { defaultConfig } from "./config.model";

export default {
  props: {
    navConfig: {
      required: false,
      default: () => defaultConfig,
    },
    value: {
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.weirdSlideAnimationAvoided = true;
    }, 500);
  },
  data: function () {
    return {
      weirdSlideAnimationAvoided: false,

      defaultConfig: defaultConfig,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (to, from) {
        if (to === true) {
          if (this.$refs["cmp-plugin-sidewindow"]) {
            this.$refs["cmp-plugin-sidewindow"].focus();
          }
        }
        // this.$refs['cmp-plugin-sidewindow'].focus();
      },
    },
  },
  methods: {
    onCloseSidewindowClick: function (event) {
      this.$emit("closed", true);
    },
    onKeyup: function (event) {
      if (event.key === "Escape") {
        this.onCloseSidewindowClick();
      }
    },
    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.cmp-plugin-sidewindow {
  &--options {
    margin: 5px 5px 0px 0px;
    float: right;
  }

  &:focus {
    outline: none;
  }
}
</style>